import React from "react";
import { Box, Loader, LoadingOverlay } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { Body } from "../../../components/Typography";
import { QueryErrorBox } from "../../../components/QueryErrorBox";

interface OrderTabContentProps<T> {
  data: T[];
  isLoading: boolean;
  error: unknown;
  emptyMessage: string;
  loadedTestId?: string;
  children: (data: T[]) => React.ReactNode;
}

export function OrderTabContent<T>({
  data,
  isLoading,
  error,
  emptyMessage,
  loadedTestId,
  children,
}: OrderTabContentProps<T>) {
  if (isLoading) {
    return (
      <Box sx={{ position: "relative", minHeight: 200 }}>
        <LoadingOverlay loader={<Loader color="brand" size="xl" />} visible={true} />
      </Box>
    );
  }

  if (error) {
    return <QueryErrorBox message="Failed to load data." error={error} />;
  }

  if (data.length === 0) {
    return (
      <Box data-testid={loadedTestId} sx={{ padding: tokens.spacing[4] }}>
        <Body>{emptyMessage}</Body>
      </Box>
    );
  }

  return (
    <div data-testid={loadedTestId} style={{ display: "contents" }}>
      {children(data)}
    </div>
  );
}
